import React from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";

const LastTenDaysProductionChart = ({ data }) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-4 border border-gray-200">
      <h3 className="text-lg font-semibold text-gray-700 mb-4 text-center">
        Son 10 Gün Üretim
      </h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="planned" fill="#00bcd4" name="Planlanan" />
          <Bar dataKey="produced" fill="#3f51b5" name="Üretilen" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LastTenDaysProductionChart;
